export type PortalVisitChannel = 'email' | 'search' | 'direct' | 'site' | 'social' | 'other'

export type PortalVisitAttribution = {
  utmSource: string
  utmMedium: string
  utmCampaign: string
  referrer: string
}

export const PORTAL_CHANNEL_LABELS: Record<PortalVisitChannel, string> = {
  email: '홍보메일',
  search: '검색',
  direct: '직접',
  site: '사이트',
  social: 'SNS',
  other: '기타',
}

const ATTRIBUTION_KEY = 'jangi.trafficAttribution'

const SEARCH_REF_RE =
  /google\.|naver\.|search\.naver|daum\.|bing\.|yahoo\.|zum\.|nate\.|search\.|duckduckgo\./i
const SOCIAL_REF_RE =
  /facebook\.|instagram\.|twitter\.|x\.com|t\.co|kakao\.|band\.us|linkedin\.|threads\.net/i
const SITE_REF_RE =
  /caion\.kr|xn--zk5b647ab9cu3avi|hamwoori\.kr|xn--ok0b647ab9cu3avi17b59gjrt|fnasolution\.kr/i

function readQueryValue(query: Record<string, unknown> | undefined, key: string) {
  const raw = query?.[key]
  if (Array.isArray(raw)) return String(raw[0] || '').trim()
  return String(raw || '').trim()
}

export function classifyVisitSource(attribution: PortalVisitAttribution): PortalVisitChannel {
  const src = attribution.utmSource.toLowerCase()
  const med = attribution.utmMedium.toLowerCase()
  const ref = attribution.referrer.toLowerCase()

  if (src === 'email' || med === 'email' || med === 'caion') return 'email'
  if (src === 'search' || med === 'organic' || med === 'cpc') return 'search'

  if (ref) {
    if (SEARCH_REF_RE.test(ref)) return 'search'
    if (SOCIAL_REF_RE.test(ref)) return 'social'
    if (SITE_REF_RE.test(ref)) return 'site'
    return 'other'
  }

  if (src || med) return 'other'
  return 'direct'
}

export function resolvePortalAttribution(query?: Record<string, unknown>): PortalVisitAttribution {
  const fromUrl: PortalVisitAttribution = {
    utmSource: readQueryValue(query, 'utm_source'),
    utmMedium: readQueryValue(query, 'utm_medium'),
    utmCampaign: readQueryValue(query, 'utm_campaign'),
    referrer: typeof document !== 'undefined' ? document.referrer || '' : '',
  }

  const hasUtm = Boolean(fromUrl.utmSource || fromUrl.utmMedium || fromUrl.utmCampaign)
  if (hasUtm) {
    try {
      sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(fromUrl))
    } catch {
      /* ignore */
    }
    return fromUrl
  }

  try {
    const stored = sessionStorage.getItem(ATTRIBUTION_KEY)
    if (stored) {
      const parsed = JSON.parse(stored) as PortalVisitAttribution
      return {
        utmSource: String(parsed.utmSource || ''),
        utmMedium: String(parsed.utmMedium || ''),
        utmCampaign: String(parsed.utmCampaign || ''),
        referrer: String(parsed.referrer || fromUrl.referrer || ''),
      }
    }
  } catch {
    /* ignore */
  }

  try {
    sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(fromUrl))
  } catch {
    /* ignore */
  }

  return fromUrl
}
